import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";

/* CinematicVideo — ana sayfada Hero'nun hemen ardından tam ekran sinematik video bölümü.
   Kullanıcının yüklediği iki lüks sahne sırayla oynar (playlist). Ses KORUNUR:
   tarayıcı kuralı gereği sessiz başlar, "Sesli İzle" düğmesiyle (kullanıcı jesti) ses açılır. */
const PLAYLIST = [
  { webm: "/video/hero-1.webm", mp4: "/video/hero-1.mp4" },
  { webm: "/video/hero-2.webm", mp4: "/video/hero-2.mp4" },
];

export function CinematicVideo() {
  const ref = useRef(null);
  const [idx, setIdx] = useState(0);
  const [soundOn, setSoundOn] = useState(false);
  const soundRef = useRef(false);
  soundRef.current = soundOn;

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    v.muted = !soundRef.current;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) v.play().catch(() => {});
        else v.pause();
      },
      { threshold: 0.15 }
    );
    io.observe(v);
    return () => io.disconnect();
  }, [idx]);

  const toggleSound = () => {
    const v = ref.current;
    setSoundOn((s) => {
      const next = !s;
      if (v) {
        v.muted = !next;
        if (next) { v.volume = 1; v.play().catch(() => {}); }
      }
      return next;
    });
  };

  const cur = PLAYLIST[idx % PLAYLIST.length];

  return (
    <section className="relative bg-[#070203] overflow-hidden" data-testid="cinematic-video-band">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent z-10" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent z-10" />
      <motion.div
        initial={{ opacity: 0, scale: 0.985 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        <video
          key={idx}
          ref={ref}
          className="w-full h-[70vh] sm:h-[88vh] object-cover"
          autoPlay
          playsInline
          preload="auto"
          onEnded={() => setIdx((i) => (i + 1) % PLAYLIST.length)}
          data-testid="cinematic-video"
        >
          <source src={cur.webm} type="video/webm" />
          <source src={cur.mp4} type="video/mp4" />
        </video>
        <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(180deg, rgba(7,2,3,0.55) 0%, transparent 18%, transparent 82%, rgba(7,2,3,0.65) 100%)" }} />
        {/* Ses düğmesi — videonun orijinal sesi korunur */}
        <button
          onClick={toggleSound}
          data-testid="cinematic-sound-toggle"
          className="absolute bottom-5 left-5 z-10 h-11 px-4 rounded-full bg-black/45 backdrop-blur border border-[#D4AF37]/35 text-[#E9CF8A] text-[12px] font-heading font-bold tracking-wider flex items-center gap-2 hover:border-[#D4AF37]/70 transition-colors"
        >
          {soundOn ? <Volume2 size={15} /> : <VolumeX size={15} />}
          {soundOn ? "Ses açık" : "Sesli izle"}
        </button>
      </motion.div>
    </section>
  );
}
